// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var $$Set = require("bs-platform/lib/js/set.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");

function compare(groupe1, groupe2) {
  if (groupe1) {
    if (groupe2) {
      return Caml_primitive.caml_int_compare(groupe1[0], groupe2[0]);
    } else {
      return -1;
    }
  } else if (groupe2) {
    return 1;
  } else {
    return 0;
  }
}

var Groupe = /* module */[/* compare */compare];

var GroupesSet = $$Set.Make(Groupe);

function discussionUrlPath(bibard, bibardSuffixe, legislature, organe) {
  return "/discussions/" + (organe + ("/" + (Pervasives.string_of_int(legislature) + ("/" + (bibard + ("/" + bibardSuffixe))))));
}

function groupeTitleFromAuteurGroupe(auteur, groupe) {
  if (groupe) {
    switch (groupe[0]) {
      case 0 : 
          return "Groupe de la Gauche démocrate et républicaine";
      case 1 : 
          return "Groupe La France insoumise";
      case 2 : 
          return "Groupe La République en Marche";
      case 3 : 
          return "Groupe Les Républicains";
      case 4 : 
          return "Groupe du Mouvement Démocrate et apparentés";
      case 5 : 
          return "Groupe Nouvelle Gauche";
      case 6 : 
          return "Groupe UDI, Agir et Indépendants";
      case 7 : 
          if (auteur[/* civilite */0] === "Mme") {
            return "Non inscrite";
          } else {
            return "Non inscrit";
          }
      
    }
  } else {
    return "";
  }
}

function shortTitleFromGroupe(groupe) {
  if (groupe) {
    switch (groupe[0]) {
      case 0 : 
          return "Gauche démocrate et républicaine";
      case 1 : 
          return "La France insoumise";
      case 2 : 
          return "La République en Marche";
      case 3 : 
          return "Les Républicains";
      case 4 : 
          return "Mouvement Démocrate et apparentés";
      case 5 : 
          return "Nouvelle Gauche";
      case 6 : 
          return "UDI, Agir et Indépendants";
      case 7 : 
          return "Non inscrits";
      
    }
  } else {
    return "~~~";
  }
}

function ste(prim) {
  return prim;
}

function urlPathFromDiscussion(discussion) {
  return discussionUrlPath(discussion[/* bibard */1], discussion[/* bibardSuffixe */2], discussion[/* legislature */4], discussion[/* organe */6]);
}

exports.Groupe = Groupe;
exports.GroupesSet = GroupesSet;
exports.discussionUrlPath = discussionUrlPath;
exports.groupeTitleFromAuteurGroupe = groupeTitleFromAuteurGroupe;
exports.shortTitleFromGroupe = shortTitleFromGroupe;
exports.ste = ste;
exports.urlPathFromDiscussion = urlPathFromDiscussion;
/* GroupesSet Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/model.re
// module id = 27
// module chunks = 0